import { ContextualField, PropertyType, } from '../../../../models/index';
import { guidEmpty } from '../../../../common/constants';

export const correspondenceTableProperties: ContextualField[] = [{
    icon: 'fa-tree',
    label: 'Correspondence table',
    modelName: 'correspondanceTableGuid',
    placeholder: 'Select a correspondence table',
    propertyName: 'correspondenceTableGuidProperty',
    propertyType: PropertyType.Select,
    extraData: {
        options: [{ key: guidEmpty, value: '' }],
        hasEmptyOption: true
    }
},
{
    icon: 'fa-hand-o-left',
    label: 'Precedent identifier',
    modelName: 'precedentCorrespondanceIdentifierGuid',
    propertyName: 'precedentCorrespondenceIdentifierGuidProperty',
    propertyType: PropertyType.ViewModel,
    required: true,
    extraData: {
    },
    messages: [{
        key: 'required',
        value: 'Precedent identifier is required for correspondence table'
    }]
}];